module.exports = __webpack_public_path__ + "a0caa18d5944b881ad0d871d874a29e5.svg";